import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import {
  COLOR_GREY_2,
  COLOR_GREY_4,
  COLOR_GREY_6,
  COLOR_WHITE,
} from "shared/theme/colors";
import { flexCenter } from "shared/theme/mixins";

export const StyledSwitcher = styled(Box)`
  display: flex;
  border-radius: 8px;
  background-color: ${COLOR_GREY_2};
  border: 1px solid ${COLOR_GREY_4};
  width: fit-content;
  box-sizing: border-box;
`;

export const StyledSwitcherOption = styled(Box, {
  shouldForwardProp: (prop) => !["isActive"].includes(prop),
})<{
  isActive: boolean;
}>`
  ${flexCenter()};
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${({ isActive }) =>
    isActive ? COLOR_WHITE : "transparent"};
  box-shadow: ${({ isActive }) =>
    isActive ? `0 0 0 1px ${COLOR_GREY_6}` : "none"};
`;

export const StyledSwitcherOptionIcon = styled(Box)`
  display: flex;
  margin: 0;
`;
